import { render, staticRenderFns } from "./ConsultaPassageiro.vue?vue&type=template&id=6bd54af0&"
import script from "./ConsultaPassageiro.vue?vue&type=script&lang=js&"
export * from "./ConsultaPassageiro.vue?vue&type=script&lang=js&"
import style0 from "./ConsultaPassageiro.vue?vue&type=style&index=0&id=6bd54af0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports